import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Rating from "@mui/material/Rating";
import Button from "@mui/material/Button";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import Link from "next/link";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CircleIcon from "@mui/icons-material/Circle";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const AgentButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "180px",
  height: "40px",
  fontSize: "15px",
  backgroundColor: "var(--primary-color)",
  borderRadius: "8px",
  "&:hover": {
    border: "1px solid var(--primary-color)",
    backgroundColor: "var(--dark-color)",
  },
  [theme.breakpoints.down("sm")]: {
    width: "150px",
  },
}));

export default function AgentCard(props) {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  let fees = [];
  props.fees.map((fee) => {
    for (const [key, value] of Object.entries(fee)) {
      fees.push({ key: FirstLetter(key.replaceAll("_", " ")), value: value });
    }
  });

  let purchased = [];
  for (const [keyp, valuep] of Object.entries(props.total_purchased)) {
    purchased.push({ key: keyp.replaceAll("_", " "), value: valuep });
  }

  return (
    <React.Fragment>
      <Card sx={{ mb: 2, borderRadius: "15px", p: 1 }} variant="outlined">
        <Box>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <CardHeader
                avatar={
                  <Avatar
                    alt="Abode finder"
                    sx={{
                      width: 90,
                      height: 90,
                      bgcolor: "var(--primary-color)",
                    }}
                    src={
                      props.photo == true
                        ? `https://buyeragents.s3.ap-southeast-2.amazonaws.com/p-${props.id}`
                        : "../assets/images/abodefinder.png"
                    }
                  />
                }
                titleTypographyProps={{ variant: "subtitle1" }}
                title={props.firstname + " " + props.lastname}
                subheader={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Rating
                      name="text-feedback"
                      value={props.stars}
                      readOnly
                      precision={0.5}
                    />
                    <Box sx={{ ml: 1, fontSize: "16px" }}>
                      {props.stars} ({props.stars_reviews})
                    </Box>
                  </Box>
                }
              />
            </Grid>
            <Grid
              container
              xs={12}
              md={6}
              sx={(theme) => ({
                justifyContent: "center",
                [theme.breakpoints.down("sm")]: { justifyContent: "flex-end" },
              })}
              alignItems="center"
            >
              <AgentButton
                variant="contained"
                sx={(theme) => ({
                  mt: 3,
                  ml: 1,
                  [theme.breakpoints.down("sm")]: { mt: 0, ml: 0, mb: 3 },
                })}
              >
                <CallIcon sx={{ mr: 2 }} />
                call
              </AgentButton>
              <AgentButton
                variant="contained"
                sx={(theme) => ({
                  mt: 3,
                  ml: 1,
                  [theme.breakpoints.down("sm")]: {
                    mt: 0,
                    ml: 1,
                    mr: 2,
                    mb: 3,
                  },
                })}
              >
                <EmailIcon sx={{ mr: 2 }} /> message
              </AgentButton>
            </Grid>
          </Grid>
        </Box>
        <CardContent>
          <Box sx={{ width: "100%" }}>
            <Box
              sx={(theme) => ({
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                [theme.breakpoints.down("sm")]: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-end",
                },
              })}
            >
              <Card
                variant="outlined"
                sx={(theme) => ({
                  width: "49%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-around",
                  backgroundColor: "#f5f5f5",
                  p: 0.8,
                  borderRadius: "10px",
                  [theme.breakpoints.down("sm")]: { width: "100%" },
                })}
              >
                <Typography variant="subtitle1" color="text.secondary">
                  Purchased (Last 12 months):
                </Typography>
                <Typography variant="subtitle1">
                  {props.total_purchased_12_month}
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={(theme) => ({
                  width: "49%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-around",
                  backgroundColor: "#f5f5f5",
                  p: 0.8,
                  borderRadius: "10px",
                  [theme.breakpoints.down("sm")]: {
                    width: "100%",
                    mt: 2,
                    flexDirection: "column",
                  },
                })}
              >
                <Typography variant="subtitle1" color="text.secondary">
                  Purchased Value (Last 12 months):
                </Typography>
                <Typography variant="subtitle1">
                  $ {abbreviateNumber(props.total_purchased_12_month_value)}
                </Typography>
              </Card>
            </Box>
          </Box>
        </CardContent>
        <CardActions disableSpacing>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            {!expanded ? <h6>View More</h6> : <h6>View Less</h6>}
            <ExpandMoreIcon
              sx={{ transform: !expanded ? "rotate(0deg)" : "rotate(180deg)" }}
            />
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Box sx={{ width: "100%", mb: 2 }}>
              <Box
                sx={(theme) => ({
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  [theme.breakpoints.down("sm")]: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  },
                })}
              >
                <Box
                  sx={(theme) => ({
                    width: "49%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    borderRadius: "10px",
                    pl: 2,
                    [theme.breakpoints.down("sm")]: { width: "100%", mt: 2 },
                  })}
                >
                  <Typography
                    sx={{ fontSize: "18px" }}
                    variant="h6"
                    component="div"
                  >
                    Total Purchased
                  </Typography>
                  <List>
                    {purchased.length == 0 ? (
                      <p></p>
                    ) : (
                      purchased.map((purchase) => {
                        return (
                          <ListItem sx={{ p: 0 }}>
                            <ListItemIcon>
                              <CircleIcon
                                sx={{ minWidth: "35px" }}
                                fontSize="12px"
                              />
                            </ListItemIcon>
                            <ListItemText>
                              <Typography
                                variant="subtitle1"
                                color="text.secondary"
                                sx={{
                                  fontSize: "16px",
                                  display: "flex",
                                  alignItems: "center",
                                  flexDirection: "row",
                                }}
                              >
                                {purchase.key} :
                                <Typography
                                  variant="subtitle1"
                                  sx={{
                                    fontSize: "16px",
                                    ml: 2,
                                    color: "#000",
                                  }}
                                >
                                  {purchase.value}
                                </Typography>
                              </Typography>
                            </ListItemText>
                          </ListItem>
                        );
                      })
                    )}
                  </List>
                </Box>
                <Box
                  sx={(theme) => ({
                    width: "49%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    borderRadius: "10px",
                    pl: 2,
                    [theme.breakpoints.down("sm")]: { width: "100%", mt: 2 },
                  })}
                >
                  <Typography
                    sx={{ fontSize: "18px" }}
                    variant="h6"
                    component="div"
                  >
                    Fees
                  </Typography>
                  <List>
                    {fees.length == 0 ? (
                      <p></p>
                    ) : (
                      fees.map((fee) => {
                        return (
                          <ListItem sx={{ p: 0 }}>
                            <ListItemIcon>
                              <CircleIcon
                                sx={{ minWidth: "35px" }}
                                fontSize="12px"
                              />
                            </ListItemIcon>
                            <ListItemText>
                              <Typography
                                variant="subtitle1"
                                color="text.secondary"
                                sx={{
                                  fontSize: "16px",
                                  display: "flex",
                                  alignItems: "center",
                                  flexDirection: "row",
                                }}
                              >
                                {fee.key} :
                                <Typography
                                  variant="subtitle1"
                                  sx={{
                                    fontSize: "16px",
                                    ml: 2,
                                    color: "#000",
                                  }}
                                >
                                  {fee.value}
                                </Typography>
                              </Typography>
                            </ListItemText>
                          </ListItem>
                        );
                      })
                    )}
                  </List>
                </Box>
              </Box>
            </Box>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={(theme) => ({
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  [theme.breakpoints.down("sm")]: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  },
                })}
              >
                <Box
                  sx={(theme) => ({
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    borderRadius: "10px",
                    [theme.breakpoints.down("sm")]: { width: "100%", mt: 2 },
                  })}
                >
                  <Card
                    variant="outlined"
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-around",
                      backgroundColor: "#f5f5f5",
                      p: 0.8,
                      borderRadius: "10px",
                    }}
                  >
                    <Typography variant="subtitle1" color="text.secondary">
                      Total Purchased Value:
                    </Typography>
                    <Typography variant="subtitle1">
                      $ {abbreviateNumber(props.total_purchased_value)}
                    </Typography>
                  </Card>
                </Box>
              </Box>
            </Box>
            <Box sx={{ width: "100%", mt: 3 }}>
              <Box
                sx={(theme) => ({
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  [theme.breakpoints.down("sm")]: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  },
                })}
              >
                <Box
                  sx={(theme) => ({
                    width: "49%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    borderRadius: "10px",
                    pl: 2,
                    [theme.breakpoints.down("sm")]: { width: "100%", mt: 2 },
                  })}
                >
                  <Typography
                    sx={{ fontSize: "18px" }}
                    variant="h6"
                    component="div"
                  >
                    Areas
                  </Typography>
                  <List>
                    {props.areas.map((area) => {
                      <ListItem sx={{ p: 0 }}>
                        <ListItemIcon>
                          <CircleIcon
                            sx={{ minWidth: "35px" }}
                            fontSize="12px"
                          />
                        </ListItemIcon>
                        <ListItemText>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontSize: "16px",
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "row",
                            }}
                          >
                            {area}
                          </Typography>
                        </ListItemText>
                      </ListItem>;
                    })}
                  </List>
                </Box>
                <Box
                  sx={(theme) => ({
                    width: "49%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    borderRadius: "10px",
                    pl: 2,
                    [theme.breakpoints.down("sm")]: { width: "100%", mt: 2 },
                  })}
                >
                  <Typography
                    sx={{ fontSize: "18px" }}
                    variant="h6"
                    component="div"
                  >
                    Qualifications
                  </Typography>
                  <List>
                    {props.qualifications.map((qualification) => {
                      <ListItem sx={{ p: 0 }}>
                        <ListItemIcon>
                          <CircleIcon
                            sx={{ minWidth: "35px" }}
                            fontSize="12px"
                          />
                        </ListItemIcon>
                        <ListItemText>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontSize: "16px",
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "row",
                            }}
                          >
                            {qualification}
                          </Typography>
                        </ListItemText>
                      </ListItem>;
                    })}
                  </List>
                </Box>
              </Box>
            </Box>
          </CardContent>
        </Collapse>
      </Card>
    </React.Fragment>
  );
}

function abbreviateNumber(value) {
  var newValue = value;
  if (value >= 1000) {
    var suffixes = ["", "k", "m", "b", "t"];
    var suffixNum = Math.floor(("" + value).length / 3);
    var shortValue = "";
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat(
        (suffixNum != 0
          ? value / Math.pow(1000, suffixNum)
          : value
        ).toPrecision(precision)
      );
      var dotLessShortValue = (shortValue + "").replace(/[^a-zA-Z 0-9]+/g, "");
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }
  return newValue;
}

function FirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
